/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { getErrorContent } from './handlers'
import Styles from './styles.module.sass'
import { Code, Box, Heading, Text, Link, VStack } from '@chakra-ui/react'

const Error = ({ error }) => {
  const { title, message, requestId } = getErrorContent(error)

  return (
    <VStack spacing={3} textAlign="center" py={10}>
      <Box>
        <Heading as="h2" mb={3} className={Styles.errorTitle}>
          {title}
        </Heading>

        <Text fontSize="lg" className={Styles.errorMessage}>
          {message}
        </Text>
      </Box>

      {requestId && (
        <Box pt={2}>
          <Text
            fontSize="xs"
            color="gray.400"
            mb={1}
            textTransform="uppercase"
            fontWeight="bold"
          >
            Troubleshooting Info
          </Text>
          <Code
            colorScheme="gray"
            variant="subtle"
            fontSize="xs"
            px={3}
            py={1}
            borderRadius="md"
          >
            {requestId}
          </Code>
        </Box>
      )}

      <Link as={RouterLink} to="/" fontWeight="700" fontSize="md" mt={6}>
        Return Home
      </Link>
    </VStack>
  )
}

export default Error
